// extracted by mini-css-extract-plugin
module.exports = {"hidden":"gameNotice_hidden__nwECy","textEmphasis":"gameNotice_textEmphasis__12r8S","noticeText":"gameNotice_noticeText__MP_fV"};